import { axiosClient } from '../axiosClient';

export type UptimeStatus = 'up' | 'degraded' | 'down' | 'paused' | 'unknown';

export interface UptimeSlot {
  at: number;
  status: UptimeStatus;
}

export interface UptimeSystem {
  key: string;
  name: string;
  url?: string;
  status: UptimeStatus;
  uptimePct: number;
  avgResponseMs: number | null;
  slots: UptimeSlot[];
  lastIncidentAt: number | null;
}

export interface UptimeResult {
  now: number;
  windowHours: number;
  slotMinutes: number;
  configured: boolean;
  systems: UptimeSystem[];
}

export const uptimeApi = {
  status: async (): Promise<UptimeResult> => {
    const { data } = await axiosClient.get<UptimeResult>('/manager/uptime');
    return data;
  },
};
